export function formatCurrency(value: any) {
	return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}
